/* eslint-disable @typescript-eslint/no-explicit-any */

import { AdaaHelper } from "../../../../../../../core/utils";
import { CountryValuesTypes } from "../../../../../../constants/enums";
import { SharedFields, textField } from "../../configs";
import {
  AccordionSectionConfigType,
  ListSectionConfigType,
  ScreenSectionConfigType,
  ScreenType,
} from "../../wf-difference.types";

const titleField: ScreenSectionConfigType[] = (() => {
  const fields = textField("title", { use: "both" }) as ScreenSectionConfigType[];

  return fields.map((field) => ({
    ...field,
    label: `common.form.label.${field.field}`,
  }));
})();

const dataSourceField: ScreenSectionConfigType[] = (() => {
  const fields = textField("dataSource", { use: "both" }) as ScreenSectionConfigType[];

  return fields.map((field) => ({
    ...field,
    label: field.field === "dataSourceAE" ? "metrics.data_source_ae" : "metrics.data_source_en",
  }));
})();

const inNumberValuesField: ListSectionConfigType = {
  field: "inNumberValues",
  label: "common.form.label.values",
  view: "list",
  idKey: "inNumberId",
  format: ($o: any) => formatValueType($o),
};

const refcode: ScreenSectionConfigType = {
  field: "refCode",
  label: "entity.create.shortName",
  view: "normal",
};

const flagField: ScreenSectionConfigType = {
  field: "flagId",
  label: "international_projects.countries.flag",
  view: "normal",
  format: ($o) => ($o as any)?.flag.filename,
  isClickable: true,
};

const iconAttachField: ScreenSectionConfigType = {
  field: "iconId",
  label: "government_scores.sectors.icon",
  view: "normal",
  format: ($o) => ($o as any)?.filename,
  isClickable: true,
};

const typeField: ScreenSectionConfigType = {
  field: "typeId",
  label: "attributes.create.data_type",
  view: "normal",
  format: ($o) => AdaaHelper.getItemValueByToken($o, "typeName"),
};

const sectorsSectionConfig: ScreenSectionConfigType[] = [...SharedFields.name, iconAttachField];

const sectorsField: AccordionSectionConfigType = {
  view: "accordion",
  field: "sector",
  title: ($o) => AdaaHelper.getItemValueByToken($o, "name"),
  idKey: "id",
  config: sectorsSectionConfig,
  label: "national_projects.national_sector.title",
};

const countryInNumbersSectionConfig: ScreenSectionConfigType[] = [
  ...titleField,
  ...SharedFields.description,
  iconAttachField,
  ...dataSourceField,
  typeField,
  inNumberValuesField,
];

const countryInNumbersField: AccordionSectionConfigType = {
  view: "accordion",
  field: "countriesInNumbersList",
  title: ($o) => AdaaHelper.getItemValueByToken($o, "title"),
  idKey: "id",
  config: countryInNumbersSectionConfig,
  label: "international_projects.countries.country_in_numbers",
};

const uaeCountriesInNumbersSectionConfig: ScreenSectionConfigType[] = [
  ...titleField,
  ...SharedFields.description,
  iconAttachField,
  typeField,
  inNumberValuesField,
];

const uaeCountriesInNumbersField: AccordionSectionConfigType = {
  view: "accordion",
  field: "uaeCountriesInNumbersList",
  title: ($o) => AdaaHelper.getItemValueByToken($o, "title"),
  idKey: "id",
  config: uaeCountriesInNumbersSectionConfig,
  label: "international_projects.countries.country_uae_in_numbers",
};

export const countriesScreenConfig = {
  type: "simple" as ScreenType,
  sections: [...SharedFields.name, refcode, flagField, sectorsField, countryInNumbersField, uaeCountriesInNumbersField],
};

const formatValueType = (data: any) => {
  switch (data.valueType) {
    case CountryValuesTypes.NUMBER:
      return data.valueNumber;
    case CountryValuesTypes.DATE:
      return AdaaHelper.formatDate(data.valueDate, false);
    case CountryValuesTypes.DATE_RANGE:
      return `${AdaaHelper.formatDate(data.startDate, false)} - ${AdaaHelper.formatDate(data.endDate, false)}`;
    case CountryValuesTypes.KEY_VALUE:
      return `${data.keyText} - ${data.valueText}`;
    case CountryValuesTypes.LIST_PER_DATE:
      return `${AdaaHelper.formatDate(data.keyDate, false)} - ${data.valueText}`;
    case CountryValuesTypes.TEXT:
      return data.valueText;
    case CountryValuesTypes.DATE_RANGE_VALUE:
      return `${AdaaHelper.formatDate(data.keyStartDate, false)} - ${AdaaHelper.formatDate(data.keyEndDate, false)}: ${
        data.valueText
      }`;
    default:
      return "";
  }
};
